export class ExpressionLanguageUtile {
  static evaluate(expression: string, context: Record<string, any>): boolean | null {
    try {
      const func = new Function(
        ...Object.keys(context),
        `return ${safeVariableAccess(expression)};`,
      );
      return func(...Object.values(context));
    } catch (error) {
      console.error('Error evaluating expression:', error);
      return null;
    }
  }

  static parseExpressionForTemplate(expression: string, context: Record<string, any>): any {
    try {
      const func = new Function('ctx', `with (ctx) { return ${safeVariableAccess(expression)}; }`);
      const nestedContext = unflatten(context);
      const result = func(nestedContext);
      if (
        typeof result === 'string' ||
        typeof result === 'number' ||
        typeof result === 'boolean' ||
        result === null
      ) {
        // string or number or boolean or null, can be displayed in the template
        return result;
      }
      try {
        return JSON.stringify(result, null, 2);
      } catch (errorStringify) {
        console.error('Error errorStringify result:', errorStringify);
        return expression;
      }
    } catch (error) {
      console.error('Error evaluating expression:', error);
      return expression;
    }
  }
}

function unflatten(obj: Record<string, unknown>) {
  const result: Record<string, any> = {};
  for (const key in obj) {
    const keys = key.split('.');
    keys.reduce((acc, part, i) => {
      if (i === keys.length - 1) {
        acc[part] = obj[key];
      } else {
        acc[part] = acc[part] || {};
      }
      return acc[part];
    }, result);
  }
  return result;
}

/**
 * Used to avoid to add `?.` everywhere in the expression.
 * Dots inside string / template literals are preserved so helpers like
 * `getJourneyParam('brand.name')` keep working.
 */
function safeVariableAccess(expression: string): string {
  let result = '';
  let i = 0;

  while (i < expression.length) {
    const ch = expression[i];

    if (ch === "'" || ch === '"' || ch === '`') {
      const quote = ch;
      result += quote;
      i += 1;
      while (i < expression.length) {
        const current = expression[i];
        result += current;
        if (current === '\\' && i + 1 < expression.length) {
          result += expression[i + 1];
          i += 2;
          continue;
        }
        i += 1;
        if (current === quote) {
          break;
        }
      }
      continue;
    }

    if (ch === '.') {
      result += result.endsWith('?') ? '.' : '?.';
      i += 1;
      continue;
    }

    result += ch;
    i += 1;
  }

  return result;
}
